import { EuiIcon } from "@inscopix/ideas-eui";
import { BadgePlain } from "../plain/BadgePlain";

interface CellValueRendererFileNotFoundProps {
  isCompact?: boolean;
}

/** Component that renders a file that was deleted or does not exist */
export const CellValueRendererFileNotFound = ({
  isCompact,
}: CellValueRendererFileNotFoundProps) => {
  return (
    <BadgePlain display="flex" height={24} color="#fec514">
      <EuiIcon size="s" type="alert" />
      {!isCompact ? "File Not Found" : null}
    </BadgePlain>
  );
};
